import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { claimsUpdated } from './claimsUpdated';

export const outputActions = [claimsUpdated];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
